import type { SitecorePageFields } from '@/cms/fields/types/common';
import { TEMPLATE_NAMES } from '@/constants';

export function isSummerPDP(pageProps: { page: { template: string }; fields: SitecorePageFields }) {
  return pageProps?.page?.template === TEMPLATE_NAMES.PDP && pageProps?.fields?._url.startsWith('/vakantie/');
}
